import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarLevel4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33333 15H2.66667C2.29848 15 2 15.2149 2 15.48V20.52C2 20.7851 2.29848 21 2.66667 21H5.33333C5.70152 21 6 20.7851 6 20.52V15.48C6 15.2149 5.70152 15 5.33333 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3333 11H7.66667C7.29848 11 7 11.2388 7 11.5333V20.4667C7 20.7612 7.29848 21 7.66667 21H10.3333C10.7015 21 11 20.7612 11 20.4667V11.5333C11 11.2388 10.7015 11 10.3333 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3333 7H12.6667C12.2985 7 12 7.25072 12 7.56V20.44C12 20.7493 12.2985 21 12.6667 21H15.3333C15.7015 21 16 20.7493 16 20.44V7.56C16 7.25072 15.7015 7 15.3333 7Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3333 3H17.6667C17.2985 3 17 3.25788 17 3.576V20.424C17 20.7421 17.2985 21 17.6667 21H20.3333C20.7015 21 21 20.7421 21 20.424V3.576C21 3.25788 20.7015 3 20.3333 3Z",
			fill: "currentColor"
		})
	]
});
export default SvgBarLevel4;
